import React from 'react'
import PropTypes from 'prop-types'
import { Icon, LockIcon } from 'src/components/icons'
import { Tooltip, ErrorTooltip, PermissionTooltip } from 'src/components/tooltips'
import { LocalizedText } from 'src/components/intl'
import { FormSection } from 'src/components/forms'
import Block from '../Block'
import { Columns } from '../../layout'
import styles from './FormBlock.scss'

const FormBlock = ({ locked, title, lockMessage, error, className, style, ...props }) => (
  <FormSection disabled={locked}>
    <PermissionTooltip allowed={!locked} className={className} style={style}>
      <ErrorTooltip error={error}>
        <Block
          className={error && styles.error}
          title={
            locked ? (
              <Columns align="baseline">
                <Tooltip className={styles.locked} popperProps={{ placement: 'top' }} title={lockMessage}>
                  <Icon icon={LockIcon} fixedWidth />
                </Tooltip>
                <div>{title}</div>
              </Columns>
            ) : (
              title
            )
          }
          {...props}
        />
      </ErrorTooltip>
    </PermissionTooltip>
  </FormSection>
)

FormBlock.defaultProps = {
  lockMessage: <LocalizedText id="WEB_FORBIDDEN_ELEMENT_EDITION" />,
}

FormBlock.propTypes = {
  toolbar: PropTypes.node,
  locked: PropTypes.bool,
  lockMessage: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  error: PropTypes.node,
  title: PropTypes.node,
  readOnly: PropTypes.bool,
}

export default FormBlock
